import { Component, EventEmitter, Input, Output, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InformacoesOperacao, Operacao, OperacaoPusher } from 'app/interfaces/Operacao';
import { MatTooltipModule } from '@angular/material/tooltip';
import { InformacoesOperacaoComponent } from '../informacoes-operacao/informacoes-operacao.component';
import { OfensorProdutividade } from 'app/interfaces/OfensorProdutividade';
import { OperacaoService } from 'app/services/operacao/operacao.service';
import { finalize } from 'rxjs';
import { MapaService } from 'app/services/mapa/mapa.service';
import { OperacaoStatus } from 'app/constants/operacao-status.constants';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-listar-operacoes',
  standalone: true,
  imports: [CommonModule, MatTooltipModule, InformacoesOperacaoComponent, TranslocoModule],
  templateUrl: './listar-operacoes.component.html',
  styleUrl: './listar-operacoes.component.css'
})
export class ListarOperacoesComponent implements OnChanges {
  @Input({required:true}) idCliente!: number;
  @Input({required:true}) dataInicio!: string;
  @Input({required:true}) dataFim!: string;
  @Input() operacoes: Operacao[] = [];
  @Output() operacaoSelecionadaEvent = new EventEmitter<boolean>();
  @Input() alteracaoEstadoOperacao!: OperacaoPusher;
  public operacoesInformacoes: InformacoesOperacao[] = [];
  public ofensoresProdutividade: OfensorProdutividade = {};
  public isLoadingInformacoes: boolean = false;
  public operacaoSelecionada: Operacao | null = null;

  constructor(
    private operacaoService: OperacaoService,
    private mapaService: MapaService,
    private translocoService: TranslocoService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['idCliente'] && !changes['idCliente'].firstChange) {
      // Limpar informações quando cliente muda
      this.operacaoSelecionada = null;
      this.operacoesInformacoes = [];
      this.ofensoresProdutividade = {};
    }
  }

  public selecionarOperacao(operacao: Operacao): void {
    if (this.operacaoSelecionada?.sr_id === operacao.sr_id) {
      this.operacaoSelecionadaEvent.emit(false);
      this.operacaoSelecionada = null;
      this.operacoesInformacoes = [];
      this.ofensoresProdutividade = {};
    } else {
      this.operacaoSelecionadaEvent.emit(true);
      this.operacaoSelecionada = operacao;
      this.carregarInformacoesOperacao(operacao.sr_id!);
    }
  }

  public carregarInformacoesOperacao(operacaoId: number): void {
    this.isLoadingInformacoes = true;
    this.operacaoService.buscarInformacoesOperacao(operacaoId, this.dataInicio, this.dataFim)
      .subscribe({
        next: (response: InformacoesOperacao) => {
          if (response) {
            this.operacoesInformacoes = [response];
            this.carregarOfensoresProdutividade();
          } else {
            this.operacoesInformacoes = [];
            this.isLoadingInformacoes = false;
          }
        },
        error: (error) => {
          this.operacoesInformacoes = [];
          this.isLoadingInformacoes = false;
        }
      });
  }

  public carregarOfensoresProdutividade(): void {
    this.mapaService
      .buscarOfensoresProdutividade(
        this.idCliente,
        undefined,
        this.operacaoSelecionada?.sr_id,
        this.dataInicio,
        this.dataFim
      )
      .pipe(
        finalize(() => {
          this.isLoadingInformacoes = false;
        })
      )
      .subscribe({
        next: (response: OfensorProdutividade) => {
          if (response) {
            this.ofensoresProdutividade = response;
          } else {
            this.ofensoresProdutividade = {};
          }
        },
        error: (error) => {
          this.ofensoresProdutividade = {};
        },
      });
  }

  public getStatusClass(status: string): string {
    const statusClasses: { [key: string]: string } = {
      'nova': 'status-nova',
      'em_andamento': 'status-em-andamento',
      'pausada': 'status-pausada',
      'cancelada': 'status-cancelada',
      'finalizada': 'status-finalizada'
    };
    return statusClasses[status] || '';
  }

  public atualizarEstadoOperacao(alteracaoEstadoOperacao: OperacaoPusher): void {
    this.operacoes = this.operacoes.map(operacao => {
      if (operacao.vc_service_id === alteracaoEstadoOperacao.vc_service_id) {
        return {
          ...operacao,
          en_estado: alteracaoEstadoOperacao.en_estado as OperacaoStatus
        };
      }
      return operacao;
    });
  }
}
